import { ApolloCache } from '@apollo/client';

type SavedInternalOrderDetails = { _id?: string; order?: string } | null | undefined;

/**
 * Points the cached `internalOrderDetails(orderId)` queries at the document a save returned
 * (DD-3231). Apollo normalizes the saved document by itself, but the first save of an order
 * creates it, and a query that read `null` before would keep showing nothing.
 */
export const linkInternalOrderDetails = <T>(cache: ApolloCache<T>, details: SavedInternalOrderDetails) => {
    if (!details?._id || !details.order) return;
    const orderArgument = `"orderId":"${details.order}"`;
    cache.modify({
        id: 'ROOT_QUERY',
        fields: {
            internalOrderDetails(existing, { storeFieldName, toReference }) {
                if (existing || !storeFieldName.includes(orderArgument)) return existing;
                return toReference({ __typename: 'InternalOrderDetails', _id: details._id });
            },
        },
    });
};
